import React, { useState, useEffect, useCallback, useRef } from "react";
import { Container } from "../ui/Container";
import { Button } from "../ui/Button";
import { cn } from "../../lib/cn";
import { getImagePath } from "../../Utils/Utilities";
import { useIsMobile } from "../../Hooks/useIsMobile";
import FeatureDetails from "../Common/FeatureDetails";
import { useBrand } from "../../Utils/BrandContext";
import { productFeatures } from "../../Constants/ProductFeatures";

// --- SUB-COMPONENT: ProductFeatureDetails (For Tick-mark clicks) ---
const ProductFeatureDetails = ({ isOpen, onClose, feature, onBuyNow }) => {
    //Back button should not throw us out of the page
    useEffect(() => {
    if (isOpen) {
      window.history.pushState({ modal: "subfeature" }, "");

      const handleBackButton = () => {
        onClose();
      };

      window.addEventListener("popstate", handleBackButton);

      return () => {
        window.removeEventListener("popstate", handleBackButton);
        if (window.history.state?.modal === "subfeature") {
          window.history.back();
        }
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen || !feature) return null;

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-4xl rounded-lg shadow-2xl relative overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="relative px-4 md:px-5 py-4 md:py-4">
          <h2 className="text-xl md:text-3xl font-bold text-[#333] leading-1 pr-12">
            {feature.title}
          </h2>
          <button
            aria-label="Close"
            onClick={onClose}
            className="absolute top-3 md:top-4 right-3 md:right-4 w-8 md:w-10 md:h-10 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-200 transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-x w-4 h-4 md:w-5 md:h-5"
              aria-hidden="true"
            >
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          </button>
        </div>

        {/* Image Body */}
        <div className="p-2 flex items-center justify-center min-h-auto md:min-h-[300px]">
          <img
            src={feature.img}
            alt={feature.title}
            className="max-w-full h-auto max-h-[500px] object-contain "
            onError={(e) => {
              e.target.src = getImagePath("/Images/Features/LeadMgmt.png");
            }}
            onClick={() =>
              window.open(feature.img, "_blank", "noopener,noreferrer")
            }
          />
        </div>

        {/* Footer: Left Aligned Button Only */}
        <div className="p-4 hidden md:flex gap-3">
          <Button
            onClick={onBuyNow}
            size="md"
            className="w-full md:flex hidden md:w-auto bg-primary text-white border-none px-7 py-3 rounded-md font-bold text-lg"
          >
            Buy Now
          </Button>
          <Button
            onClick={onClose}
            size="md"
            variant="outline"
            className="w-full md:flex hidden md:w-auto px-7 py-2 rounded-md font-bold text-lg"
          >
            Close
          </Button>
        </div>
        <div className="p-4 md:hidden flex">
          <Button
            onClick={onBuyNow}
            size="sm"
            className="w-full flex md:hidden md:w-auto bg-primary text-white border-none px-8 py-3 rounded-md font-bold text-lg"
          >
            Buy Now
          </Button>
        </div>
      </div>
    </div>
  );
};

const ProductFeatures = ({ onBuyNow, onFeatureClick }) => {
  const isMobile = useIsMobile();
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [selectedSubFeature, setSelectedSubFeature] = useState(null);
  const { brand: activeBrand } = useBrand();

  const handleModalBuyNow = useCallback(() => {
    setSelectedFeature(null);
    setSelectedSubFeature(null);
    document.body.style.overflow = '';
    
    if (onBuyNow) {
      setTimeout(() => {
        onBuyNow();
      }, 100);
    }
  }, [onBuyNow]);

//   const features = [
//     {
//       id: "crm",
//       title: "CRM",
//       img: "/Images/Icons/Leads.png",
//       tagline: "Convert more Inquiries to Sales!",
//       items: [
//           "Import from IndiaMART, TradeIndia, JustDial, Meta (FB), 99acres, MagicBricks",
//           "Assign Leads to Team",
//           "Monitor Interactions & Appointments",
//           "Monitor Visits and Travel History Logs",
//           "Track Prospects in Stages of Conversion",
//           "Analyze Performance & Rejections",
//         ],
//       screens: [
//         {
//           sTitle: "Lead Integrations",
//           sPic: getImagePath("/Images/Features/LeadIntegrations.png"),
//         },
//         {
//           sTitle: "Lead Management",
//           sPic: getImagePath("/Images/Features/LeadMgmt.png"),
//         },
//         {
//           sTitle: "Interactions & Appointments",
//           sPic: getImagePath("/Images/Features/LeadProspInxnsNew.png"),
//         },
//         {
//           sTitle: "Travel History Log",
//           sPic: getImagePath("/Images/Features/LeadProspTravelHistory.png"),
//         },
//         {
//           sTitle: "Prospect Funnel",
//           sPic: getImagePath("/Images/Features/LeadProspFunnel.png"),
//         },
//         {
//           sTitle: "Analysis using Leads Dashboard",
//           sPic: getImagePath("/Images/Features/LeadDashboard.png"),
//         }

//       ],
//       faqs: [
//   { q: "Can I import leads from IndiaMART automatically?", a: "Yes, leads from IndiaMART, TradeIndia, JustDial, and Meta (Facebook) forms are imported automatically without manual entry." },
//   { q: "Can multiple sales team members be assigned different leads?", a: "Yes, you can assign leads to specific team members and monitor their interactions, visits, and follow-up activity from a central dashboard." },
//   { q: "How does the prospect funnel work?", a: "Leads are tracked through customizable stages of conversion — from initial inquiry to negotiation to closure — giving you a visual pipeline of your sales progress." },
//   { q: "Can I track the travel history of my field sales team?", a: "Yes, the geo-tag feature logs visits with location data, so you can see where and when your team met prospects." },
//   { q: "What reports does CRM provide?", a: "CRM provides performance analysis by team member, rejection reason analysis, stage-wise conversion rates, and lead source effectiveness reports." },
//   { q: "Is mobile access available for CRM?", a: "Yes, the CRM is fully accessible from mobile devices, allowing field staff to update interactions and appointments on the go." },
// ],

//     },
//     {
//       id: "quotations",
//       title: "Quotations",
//       img: "/Images/Icons/Quotations.png",
//       tagline: "Impress customer to seal the deal!",
//       items: [
//         "Create Quotations & Proforma Invoices",
//         "Share via WhatsApp Web or Email",
//         "Manage Templates and Revisions",
//         "Add Product Images",
//         "Customize Document Series",
//       ],
//       screens: [
//         {
//           sTitle: "Manage Quotes & Proforma Invoices",
//           sPic: getImagePath("/Images/Features/QuoteList.png"),
//         },
//         {
//           sTitle: "Share via WhatsApp, Email",
//           sPic: getImagePath("/Images/Features/QuoteShare.png"),
//         },
//         {
//           sTitle: "Quote Print Sample",
//           sPic: getImagePath("/Images/Features/QuotePrint.png"),
      
//         },
//         {
//           sTitle: "Product Image in Quotation",
//           sPic: getImagePath("/Images/Features/QuotePrint.png"),
//         },
//         {
//           sTitle: "Customize Document Series",
//           sPic: getImagePath("/Images/Features/InvoiceDocSeries.png"),
//         },

//       ],
//       faqs: [
//   { q: "Can I create both Quotations and Proforma Invoices?", a: "Yes, the system supports both Quotations and Proforma Invoices from the same module with separate document series." },
//   { q: "How do I share a quotation with a customer?", a: "You can share directly via WhatsApp Web or Email with one click from within the quotation screen." },
//   { q: "Can I manage multiple quotation templates?", a: "Yes, you can create and manage multiple print templates and switch between them per quotation." },
//   { q: "Does the system track if the customer opened the quotation?", a: "Yes, quotation opens and conversions are monitored, helping you prioritize follow-ups." },
//   { q: "Can I revise a quotation and track versions?", a: "Yes, revision management is built in — you can create new revisions and compare them with the original." },
// ],
//     },
//     {
//       id: "sales-orders",
//       title: "Orders",
//       img: "/Images/Icons/Orders.png",
//       tagline: "Delight customers, win repeat business!",
//       items: [
//         "Manage Sales Orders",
//         "Send Smart Acknowledgement",
//         "Give Status Updates",
//         "Get Feedback & Google Rating",
//         "Customize Document Series",
//         "Monitor through Reports",
//       ],
//       screens: [
//         {
//           sTitle: "Manage Sales Orders",
//           sPic: getImagePath("/Images/Features/InvoiceList.png"),
//         },
//         {
//           sTitle: "Share via WhatsApp, Email",
//           sPic: getImagePath("/Images/Features/InvoiceShare.png"),
//         },
//         {
//           sTitle: "Give Status Updates",
//           sPic: getImagePath("/Images/Features/OrdStatusUpdate.png"),
//         },
//         {
//           sTitle: "Get Feedback",
//           sPic: getImagePath("/Images/Features/OrdFeedback.png"),
//         },
//         {
//           sTitle: "Customize Document Series",
//           sPic: getImagePath("/Images/Features/InvoiceDocSeries.png"),
//         },
//         {
//           sTitle: "Monitor through Reports",
//           sPic: getImagePath("/Images/Features/InvoiceReports.png"),
//         }
//       ],
//       faqs: [
//   { q: "Can customers receive an acknowledgement for their order?", a: "Yes, a smart acknowledgement is sent automatically on order entry via WhatsApp or Email." },
//   { q: "Can I send dispatch notifications?", a: "Yes, dispatch notifications are triggered when an order is marked dispatched, keeping customers informed." },
//   { q: "How does the feedback and Google Rating feature work?", a: "After delivery, the system sends a feedback request with a Google rating link, helping you collect reviews automatically." },
//   { q: "Can I customize document series for orders?", a: "Yes, you can define custom prefixes and numbering sequences for your sales order documents." },
//   { q: "What reports are available for orders?", a: "You can view order-wise, party-wise, and date-wise reports with status tracking for each order." },
// ],
//     },
//     {
//       id: "billing",
//       title: "Billing",
//       img: "/Images/Icons/Billing.png",
//       tagline: "Simplify, Comply, Enjoy!",
//       items: [
//         "Generate GST Invoices",
//         "Link with POS for Retail",
//         "Generate E-way Bills",
//         "Customize Document Series",
//         "Send via WhatsApp Web or Email",
//         "Analyze Trade Profitability",
//         "GST Compliance (GSTR-1 & 3B JSONs)",
//         "Manage EWB, E-Invoice, GST",
//       ],
//       screens: [
//         {
//           sTitle: "Create Party Invoices",
//           sPic: getImagePath("/Images/Features/InvoiceEntryB2B.png"),
//         },
//         {
//           sTitle: "Invoice Print Sample (POS)",
//           sPic: getImagePath("/Images/Features/InvoicePrintCashMemo.png"),
//         },
//         {
//           sTitle: "Generate E-way Bills",
//           sPic: getImagePath("/Images/Features/InvoiceEway.png"),
//         },
//         {
//           sTitle: "Customize Auto Document Series",
//           sPic: getImagePath("/Images/Features/InvoiceDocSeries.png"),
//         },
//         {
//           sTitle: "Share via WhatsApp, Email",
//           sPic: getImagePath("/Images/Features/InvoiceShare.png"),
//         },
//         {
//           sTitle: "Analyze Trade Profitability",
//           sPic: getImagePath("/Images/Features/InvoiceRptTradeProfitability.png"),
//         },
//         {
//           sTitle: "GST Compliance (GSTR-1 & 3B JSONs)",
//           sPic: getImagePath("/Images/Features/InvoiceGSTR3B.png"),
//         },
//         {
//           sTitle: "Invoice Print Sample (E-Invoice)",
//           sPic: getImagePath("/Images/Features/InvoicePrintEInvoice.png"),
//         },

//         // {
//         //   sTitle: "Manage Invoices (B2B, POS, Export)",
//         //   sPic: getImagePath("/Images/Features/InvoiceList.png"),
//         // },
//         // {
//         //   sTitle: "Invoice Print Sample (B2B)",
//         //   sPic: getImagePath("/Images/Features/InvoicePrintB2B.png"),
//         // },
//         // {
//         //   sTitle: "Invoice Print Sample (Export)",
//         //   sPic: getImagePath("/Images/Features/InvoicePrintExport.png"),
//         // },
//         // {
//         //   sTitle: "Deliver Invoices Impressively",
//         //   sPic: getImagePath("/Images/Features/InvoiceTP.png"),
//         // },
//         // {
//         //   sTitle: "Monitor through Reports",
//         //   sPic: getImagePath("/Images/Features/InvoiceReports.png"),
//         // },
//       ],
//       faqs: [
//         { q: "Can I track outstanding bill-by-bill?", a: "Yes, receivables are tracked bill-wise, so you always know exactly which invoices are unpaid and for how long." },
//         { q: "How do I send payment reminders?", a: "Payment reminders can be sent via WhatsApp with outstanding details included, directly from the recovery module." },
//         { q: "Is RazorPay integration available for online payments?", a: "Yes, you can link your RazorPay account to send payment links to customers and receive online payments." },
//         { q: "Does the system send a thank-you note after payment?", a: "Yes, a thank-you message is automatically sent to the customer when their payment is recorded." },
//         { q: "Can I see an aging report of my receivables?", a: "Yes, receivable aging reports are available categorized by time periods like 0–30, 30–60, 60–90 days etc." },
//       ],
//     },
//     {
//       id: "recovery",
//       title: "Recovery",
//       img: "/Images/Icons/Payment Recovery.png",
//       tagline: "Collect smartly & quickly!",
//       items: [
//         "Track Bill-wise Receivables",
//         "Send Follow-up Reminders",
//         "Link to RazorPay Gateway",
//         "Send Thank You Note on Receipt",
//       ],
//       screens: [
//         {
//           sTitle: "Track Receivables & Outstanding",
//           sPic: getImagePath("/Images/Features/InvoiceList.png"),
//         },
//         {
//           sTitle: "Share Payment Reminders via WhatsApp",
//           sPic: getImagePath("/Images/Features/InvoiceShare.png"),
//         },
//         {
//           sTitle: "Offer Easy Payment Options",
//           sPic: getImagePath("/Images/Features/InvoiceTP.png"),
//         },
//         {
//           sTitle: "Send Thank You note",
//           sPic: getImagePath("/Images/Features/ThankYouNote.png"),
//         },
//       ],
//     },
//     {
//       id: "accounts",
//       title: "Accounts",
//       img: "/Images/Icons/Accounts.png",
//       tagline: "Monitor from your Mobile!",
//       items: [
//         "Access Real-time Accounts from Your Mobile",
//                 "Track Key Ledgers Easily",
//         "Enter Vouchers Easily",
//         "Get Balance Sheet, P&L, etc.",
//         "Generate GSTR-1 & 3B JSON",
//         "Manage Multiple Branches",
//       ],
//       screens: [
//         {
//           sTitle: "Access Real-time Accounts from your Mobile",
//           sPic: getImagePath("/Images/Features/AccountsDsbdMob.png"),
//         },
//         {
//           sTitle: "CEO-friendly Easy Accounting",
//           sPic: getImagePath("/Images/Features/AccountsDsbd.png"),
//         },
//         {
//           sTitle: "Enter Vouchers Easily",
//           sPic: getImagePath("/Images/Features/AccountsVoucherEntry.png"),
//         },
//         // {
//         //   sTitle: "Enter Vouchers (Mobile)",
//         //   sPic: getImagePath("/Images/Features/AccountsVoucherEntryMob.png"),
//         // },
//         {
//           sTitle: "Access Live Statements",
//           sPic: getImagePath("/Images/Features/AccountsStatements.png"),
//         },
//         // {
//         //   sTitle: "Access Live Statements (Mobile)",
//         //   sPic: getImagePath("/Images/Features/AccountsP&LMob.png"),
//         // },
//         {
//           sTitle: "Simplify GST Compliance",
//           sPic: getImagePath("/Images/Features/InvoiceGSTR3B.png"),
//         },
//         {
//           sTitle: "Manage Multiple Branches",
//           sPic: getImagePath("/Images/Features/AccountsMultiBranch.png"),
//         },
//       ]
//     },
//     {
//       id: "purchase",
//       title: "Purchase",
//       img: "/Images/Icons/Purchase.png",
//       tagline: "Get more from your Suppliers!",
//       items: [
//         "Generate Purchase Orders",
//         "Manage Supplier Invoices",
//         // "Get Status Update from Suppliers",
//         "Plan based on Inventory Shortfall"
//       ],
//       screens: [
//         {
//           sTitle: "Generate Purchase Order",
//           sPic: getImagePath("/Images/Features/PurchaseOrder.png"),
//         },
//         {
//           sTitle: "Manage Supplier Invoice",
//           sPic: getImagePath("/Images/Features/SupplierInvoice.png"),
//         },
      
//         // {
//         //   sTitle: "Track Inventory Stock",
//         //   sPic: getImagePath("/Images/Features/InventoryStockList.png"),
//         // },
//           {
//           sTitle: "Observe Items with Insufficient Stock",
//           sPic: getImagePath("/Images/Features/InventoryInsufficient.png"),
//         },
//       ],
//     },
//     {
//       id: "inventory",
//       title: "Inventory",
//       img: "/Images/Icons/Inventory.png",
//       tagline: "Stock smartly!",
//       items: [
//         "Track Inventory Stock",
//         "Manage Stock at Multiple Stores",
//         "Observe Items with Insufficient Stock",
//         "Easy Item Entry",
//         "Log Batches & Expiry Dates",
//         "Manage BOM (Bill of Materials)",
//         "Track Inventory Transactions",
//         "Monitor through Reports"
//       ],
//       screens: [
//         {
//           sTitle: "Track Inventory Stock",
//           sPic: getImagePath("/Images/Features/InventoryStockList.png"),
//         },
//         {
//           sTitle: "Manage Stock at Multiple Stores",
//           sPic: getImagePath("/Images/Features/InventoryStores.png"),
//         },
//         {
//           sTitle: "Observe Items with Insufficient Stock",
//           sPic: getImagePath("/Images/Features/InventoryInsufficient.png"),
//         },
//         {
//           sTitle: "Easy Item Entry",
//           sPic: getImagePath("/Images/Features/InventoryItemEntry.png"),
//         },
//         {
//           sTitle: "Log Batches & Expiry Dates",
//           sPic: getImagePath("/Images/Features/InventoryItemBatches.png"),
//         },
//         {
//           sTitle: "Manage BOM (Bill of Materials)",
//           sPic: getImagePath("/Images/Features/InventoryBOM.png"),
//         },
//         {
//           sTitle: "Track Inventory Transactions",
//           sPic: getImagePath("/Images/Features/InventoryXnTypes.png"),
//         },
//         {
//           sTitle: "Monitor through Reports",
//           sPic: getImagePath("/Images/Features/InventoryReports.png"),
//         },
//       ],
//     },
//     {
//       id: "manufacturing",
//       title: "Production",
//       img: "/Images/Icons/Manufacturing.png",
//       tagline: "Make (smartly) in India!",
//       items: [
//         "Launch Production Jobs",
//         "Track WIP at Process Stages",
//         "Monitor Material Consumption vs BOM",
//         "Analyze Rejection Reasons",
//         "Track Job Status against Plan",
//         "Print Manufacturing Job Card"
//       ],
//       screens: [
//         {
//           sTitle: "Easy Production Job Entry",
//           sPic: getImagePath("/Images/Features/ProductionJobEntry.png"),
//         },
//         {
//           sTitle: "Monitor Manufacturing (WIP) Jobs",
//           sPic: getImagePath("/Images/Features/ProductionList.png"),
//         },

//         {
//           sTitle: "Track Job Status, Monitor Issued Materials",
//           sPic: getImagePath("/Images/Features/ProductionJobDetails.png"),
//         },
//         {
//           sTitle: "Monitor through Reports",
//           sPic: getImagePath("/Images/Features/ProductionReports.png"),
//         },
//         // {
//         //   sTitle: "Update Job Stages",
//         //   sPic: getImagePath("/Images/Features/ProductionJobMovement.png"),
//         // },
//         {
//           sTitle: "Track Job Status against Plan",
//           sPic: getImagePath("/Images/Features/ProductionJobTracking.png"),
//         },
//         // {
//         //   sTitle: "Receive Finished Goods at Job Completion",
//         //   sPic: getImagePath("/Images/Features/ProductionReceiveFG.png"),
//         // },
//         // {
//         //   sTitle: "Return Unused Material to Store",
//         //   sPic: getImagePath("/Images/Features/ProductionReceiveUnused.png"),
//         // },
//         {
//           sTitle: "Manufacturing Job Card Print Sample",
//           sPic: getImagePath("/Images/Features/ProductionJobCard.png"),
//         }
//       ],
//     },
//     {
//       id: "support",
//       title: "Support",
//       img: "/Images/Icons/Support Ticketing.png",
//       tagline: "Quicken Customer Care!",
//       items: [
//         "Enter & Acknowledge Support Tickets",
//         "Track for Timely Completion",
//         "Request Feedback on Satisfaction"
//       ],
//       screens: [
//         {
//           sTitle: "Support Tickets Management",
//           sPic: getImagePath("/Images/Features/Support.png"),
//         },
//         {
//           sTitle: "Track Status",
//           sPic: getImagePath("/Images/Features/SupportDue.png"),
//         },
//         {
//           sTitle: "Support Feedback",
//           sPic: getImagePath("/Images/Features/SupportFeedback.png"),
//         },
//       ],
//     },
//     {
//       id: "contracts",
//       title: "Contracts",
//       img: "/Images/Icons/Contracts.png",
//       tagline: "Renew in time!",
//       items: [
//         "Enter Contracts Easily",
//         "Track Contracts & Subscriptions",
//         "Attach Contract File"
//       ],
//       screens: [
//         {
//           sTitle: "Enter Contracts Easily",
//           sPic: getImagePath("/Images/Features/ContractEntry.png"),
//         },
//         {
//           sTitle: "Track Contracts & Subscriptions",
//           sPic: getImagePath("/Images/Features/ContractManage.png"),
//         },
//         {
//           sTitle: "Attach Contract File",
//           sPic: getImagePath("/Images/Features/ContractEntry.png"),
//         },
//       ],
//     },
//     {
//       id: "tasks",
//       title: "Tasks",
//       img: "/Images/Icons/Tasks.png",
//       tagline: "Stay Organized!",
//       items: [
//         "Finish own tasks (Inbox)",
//         "Monitor delegated tasks (Outbox)",
//         "Log completed/paused tasks"
//       ],
//       screens: [
//         {
//           sTitle: "Manage Own Tasks in Inbox",
//           sPic: getImagePath("/Images/Features/TasksDesktop.png"),
//         },
//         {
//           sTitle: "Track Delegated Tasks in Outbox",
//           sPic: getImagePath("/Images/Features/TaskOutbox.png"),
//         },
//         {
//           sTitle: "Log Tasks",
//           sPic: getImagePath("/Images/Features/TaskPause.png"),
//         },
//       ],
//     },
//   ];

//   const features = [
//     {
//       id: "crm",
//       title: "CRM",
//       img: "/Images/Icons/Leads.png",
//       tagline: "Convert more Inquiries to Sales!",
//       items: [
//           "Import from IndiaMART, TradeIndia, JustDial, Meta (FB), 99acres, MagicBricks",
//           "Assign Leads to Team",
//           "Monitor Interactions & Appointments",
//           "Monitor Visits and Travel History Logs",
//           "Track Prospects in Stages of Conversion",
//           "Analyze Performance & Rejections",
//         ],
//       screens: [
//         {
//           sTitle: "Lead Integrations",
//           sPic: getImagePath("/Images/Features/LeadIntegrations.png"),
//         },
//         {
//           sTitle: "Lead Management",
//           sPic: getImagePath("/Images/Features/LeadMgmt.png"),
//         },
//         {
//           sTitle: "Interactions & Appointments",
//           sPic: getImagePath("/Images/Features/LeadProspInxnsNew.png"),
//         },
//         {
//           sTitle: "Travel History Log",
//           sPic: getImagePath("/Images/Features/LeadProspTravelHistory.png"),
//         },
//         {
//           sTitle: "Prospect Funnel",
//           sPic: getImagePath("/Images/Features/LeadProspFunnel.png"),
//         },
//         {
//           sTitle: "Analysis using Leads Dashboard",
//           sPic: getImagePath("/Images/Features/LeadDashboard.png"),
//         }
//       ],
//       faqs: [
//         { q: "Can I import leads from Excel or other lead platforms?", a: "Yes. You can import leads using our Excel template or directly import them from platforms like <b>IndiaMART, TradeIndia, JustDial, Meta Forms, 99Acres, MagicBricks</b>, or through your <b>website API.</b>" },
//         { q: "Can I reassign leads to another team member?", a: "Yes. Simply open the lead, click <b>Reassign</b>, and select the executive you want to assign it to." },
//         { q: "Can I convert a lead into a customer and still keep it as a lead?", a: "Yes. When converting a lead into a customer, the system asks if you want to <b>keep the lead record as a lead as well.</b>" },
//         { q: "Can I add extra fields in lead details?", a: "Yes. In QikERP, you can add <b>custom fields</b> in lead details to store information according to your business needs." },
//       ],
//     },
//     {
//       id: "quotations",
//       title: "Quotations",
//       img: "/Images/Icons/Quotations.png",
//       tagline: "Impress customer to seal the deal!",
//       items: [
//         "Create Quotations & Proforma Invoices",
//         "Share via WhatsApp Web or Email",
//         "Manage Templates and Revisions",
//         "Add Product Images",
//         "Customize Document Series",
//       ],
//       screens: [
//         {
//           sTitle: "Manage Quotes & Proforma Invoices",
//           sPic: getImagePath("/Images/Features/QuoteList.png"),
//         },
//         {
//           sTitle: "Share via WhatsApp, Email",
//           sPic: getImagePath("/Images/Features/QuoteShare.png"),
//         },
//         {
//           sTitle: "Quote Print Sample",
//           sPic: getImagePath("/Images/Features/QuotePrint.png"),
//         },
//         {
//           sTitle: "Product Image in Quotation",
//           sPic: getImagePath("/Images/Features/QuotePrint.png"),
//         },
//         {
//           sTitle: "Customize Document Series",
//           sPic: getImagePath("/Images/Features/InvoiceDocSeries.png"),
//         },
//       ],
//       faqs: [
//         { q: "Can I create quotations with product images?", a: "Yes. You can add product images in quotations to <b>present your products more clearly to customers.</b>" },
//         { q: "Can I customize the quotation format according to my business?", a: "Yes. You can adjust <b>print settings</b> and choose what information appears in the quotation so <b>it matches your business needs.</b>" },
//         { q: "Can I add extra columns or fields in quotations?", a: "Yes. You can add <b>up to 5 additional columns or fields</b> in quotations to <b>capture extra details required for your business.</b>" },
//         { q: "Can I send quotations directly from QikERP?", a: "Yes. You can send quotations directly to customers via <b>Email or WhatsApp</b>, making it <b>faster to share quotes and close deals.</b>" },
//       ],
//     },
//     {
//       id: "sales-orders",
//       title: "Orders",
//       img: "/Images/Icons/Orders.png",
//       tagline: "Delight customers, win repeat business!",
//       items: [
//         "Manage Sales Orders",
//         "Send Smart Acknowledgement",
//         "Give Status Updates",
//         "Get Feedback & Google Rating",
//         "Customize Document Series",
//         "Monitor through Reports",
//       ],
//       screens: [
//         {
//           sTitle: "Manage Sales Orders",
//           sPic: getImagePath("/Images/Features/InvoiceList.png"),
//         },
//         {
//           sTitle: "Share via WhatsApp, Email",
//           sPic: getImagePath("/Images/Features/InvoiceShare.png"),
//         },
//         {
//           sTitle: "Give Status Updates",
//           sPic: getImagePath("/Images/Features/OrdStatusUpdate.png"),
//         },
//         {
//           sTitle: "Get Feedback",
//           sPic: getImagePath("/Images/Features/OrdFeedback.png"),
//         },
//         {
//           sTitle: "Customize Document Series",
//           sPic: getImagePath("/Images/Features/InvoiceDocSeries.png"),
//         },
//         {
//           sTitle: "Monitor through Reports",
//           sPic: getImagePath("/Images/Features/InvoiceReports.png"),
//         }
//       ],
//       faqs: [
//         { q: "Can I create sales orders in QikERP?", a: "Yes. You can easily create and manage sales orders in QikERP." },
//         { q: "Can I track order status?", a: "Yes. You can track order status and also create custom stages according to your business process." },
//         { q: "Can I convert a quotation into an order?", a: "Yes. You can easily convert a quotation into a sales order in QikERP." },
//         { q: "Can I create an order directly from an invoice?", a: "Yes. QikERP allows you to create an order directly from an invoice if required." },
//         { q: "Can I see all pending and completed orders?", a: "Yes. You can view all pending and completed orders, along with delay logs to understand why orders were delayed." },
//         { q: "Can multiple team members manage orders?", a: "Each order has one primary person responsible, but other team members can view or update it if they are given the required permissions." },
//         { q: "Can I notify customers when the order status changes?", a: "Yes. You can notify customers via <b>Email or WhatsApp</b> when the order status is updated." },
//       ],
//     },
//     {
//       id: "billing",
//       title: "Billing",
//       img: "/Images/Icons/Billing.png",
//       tagline: "Simplify, Comply, Enjoy!",
//       items: [
//         "Generate GST Invoices",
//         "Configure your invoice format",
//         "Generate E-way Bills",
//         "Customize Document Series",
//         "Send via WhatsApp Web or Email",
//         "Analyze Trade Profitability",
//         "GST Compliance (GSTR-1 & 3B JSONs)",
//         "Manage E-Invoice",
//       ],
//       screens: [
//         {
//           sTitle: "Create Party Invoices",
//           sPic: getImagePath("/Images/Features/InvoiceEntryB2B.png"),
//         },
//         {
//           sTitle: "Invoice Format",
//           sPic: getImagePath("/Images/Features/PrintHeader.png"),
//         },
//         {
//           sTitle: "Generate E-way Bills",
//           sPic: getImagePath("/Images/Features/InvoiceEway.png"),
//         },
//         {
//           sTitle: "Customize Auto Document Series",
//           sPic: getImagePath("/Images/Features/InvoiceDocSeries.png"),
//         },
//         {
//           sTitle: "Share via WhatsApp, Email",
//           sPic: getImagePath("/Images/Features/InvoiceShare.png"),
//         },
//         {
//           sTitle: "Analyze Trade Profitability",
//           sPic: getImagePath("/Images/Features/InvoiceRptTradeProfitability.png"),
//         },
//         {
//           sTitle: "GST Compliance (GSTR-1 & 3B JSONs)",
//           sPic: getImagePath("/Images/Features/InvoiceGSTR3B.png"),
//         },
//         {
//           sTitle: "Invoice Print Sample (E-Invoice)",
//           sPic: getImagePath("/Images/Features/InvoicePrintEInvoice.png"),
//         },
//       ],
//       faqs: [
//         { q: "Can I create a dispatch from an invoice in QikERP?", a: "Yes. You can create a dispatch directly from the invoice inside QikERP, making order fulfillment quick and simple." },
//         { q: "Can I generate E-Way Bills from QikERP?", a: "Yes. Simply connect your GST account with QikERP and generate <b>E-Way Bills directly from the system.</b>" },
//         { q: "Can I analyze my sales performance?", a: "Yes. QikERP provides detailed sales reports like Daily & Monthly Sales Analysis, Trade Profitability, Customer Repeat Business, Feedback Analysis, and Sales Team Performance. These reports help you understand trends, track performance, and make better business decisions." },
//         { q: "Can I edit an invoice after creating it?", a: "Yes. You can edit an invoice and update details whenever required." },
//         { q: "Can I add discounts or extra charges in an invoice?", a: "Yes. You can add <b>discounts</b> as well as <b>additional charges</b> in invoices as needed." },
//       ],
//     },
//     {
//       id: "recovery",
//       title: "Recovery",
//       img: "/Images/Icons/Payment Recovery.png",
//       tagline: "Collect smartly & quickly!",
//       items: [
//         "Track Bill-wise Receivables",
//         "Send Follow-up Reminders",
//         "Link to RazorPay Gateway",
//         "Send Thank You Note on Receipt",
//       ],
//       screens: [
//         {
//           sTitle: "Track Receivables & Outstanding",
//           sPic: getImagePath("/Images/Features/InvoiceList.png"),
//         },
//         {
//           sTitle: "Share Payment Reminders via WhatsApp",
//           sPic: getImagePath("/Images/Features/InvoiceShare.png"),
//         },
//         {
//           sTitle: "Offer Easy Payment Options",
//           sPic: getImagePath("/Images/Features/InvoiceTP.png"),
//         },
//         {
//           sTitle: "Send Thank You note",
//           sPic: getImagePath("/Images/Features/ThankYouNote.png"),
//         },
//       ],
//       faqs: [
//         { q: "Can I track pending payments from customers?", a: "Yes. The Recovery module shows all pending receivables in one place so you can <b>monitor outstanding payments easily.</b> " },
//         { q: "Can I send payment reminders to customers?", a: "Yes. You can send reminders through <b>Email or WhatsApp</b>, helping you <b>follow up faster and improve payment collection.</b>" },
//         { q: "Can I update receivable amounts after receiving payment?", a: "Yes. You can update amounts when full or partial payment is received so your <b>records always stay accurate.</b> " },
//         { q: "Can I see all pending payments in one place?", a: "Yes. The Recovery list shows all pending receivables with customer details so you can <b>quickly identify who still needs to pay.</b>" },
//       ],
//     },
//     {
//       id: "accounts",
//       title: "Accounts",
//       img: "/Images/Icons/Accounts.png",
//       tagline: "Monitor from your Mobile!",
//       items: [
//         "Access Real-time Accounts from Your Mobile",
//         "Track Key Ledgers Easily",
//         "Enter Vouchers Easily",
//         "Get Balance Sheet, P&L, etc.",
//         "Generate GSTR-1 & 3B JSON",
//         "Manage Multiple Branches",
//       ],
//       screens: [
//         {
//           sTitle: "Access Real-time Accounts from your Mobile",
//           sPic: getImagePath("/Images/Features/AccountsDsbdMob.png"),
//         },
//         {
//           sTitle: "CEO-friendly Easy Accounting",
//           sPic: getImagePath("/Images/Features/AccountsDsbd.png"),
//         },
//         {
//           sTitle: "Enter Vouchers Easily",
//           sPic: getImagePath("/Images/Features/AccountsVoucherEntry.png"),
//         },
//         {
//           sTitle: "Access Live Statements",
//           sPic: getImagePath("/Images/Features/AccountsStatements.png"),
//         },
//         {
//           sTitle: "Simplify GST Compliance",
//           sPic: getImagePath("/Images/Features/InvoiceGSTR3B.png"),
//         },
//         {
//           sTitle: "Manage Multiple Branches",
//           sPic: getImagePath("/Images/Features/AccountsMultiBranch.png"),
//         },
//       ],
//       faqs: [
//         { q: "Can I enter accounting vouchers?", a: "Yes. You can record vouchers directly, making it easy to update accounts anytime." },
//         { q: "Can I track important ledgers easily?", a: "Yes. QikERP lets you track key ledgers and monitor balances whenever required." },
//         { q: "Can I see financial reports like Balance Sheet and Profit & Loss?", a: "Yes. You can generate reports like <b>Balance Sheet, Profit & Loss, and other financial summaries</b> to understand your business performance." },
//         { q: "Can I generate GST reports like GSTR-1 and GSTR-3B?", a: "Yes. QikERP allows you to generate <b>GSTR-1 and GSTR-3B JSON</b> files for GST filing." },
//         { q: "Can I import my existing ledgers from Excel?", a: "Yes. You can easily import ledgers using an Excel template to set up your accounts quickly." },
//         { q: "Can I export accounting data to Tally?", a: "Yes. You can export accounting data from QikERP and use it in <b>Tally</b> when needed." },
//         { q: "Can I create Credit Notes and Debit Notes?", a: "Yes. You can create <b>Credit Notes and Debit Notes</b> to manage returns, adjustments, or corrections in transactions." },
//       ],
//     },
//     {
//       id: "purchase",
//       title: "Purchase",
//       img: "/Images/Icons/Purchase.png",
//       tagline: "Get more from your Suppliers!",
//       items: [
//         "Generate Purchase Orders",
//         "Manage Supplier Invoices",
//         "Plan based on Inventory Shortfall"
//       ],
//       screens: [
//         {
//           sTitle: "Generate Purchase Order",
//           sPic: getImagePath("/Images/Features/PurchaseOrder.png"),
//         },
//         {
//           sTitle: "Manage Supplier Invoice",
//           sPic: getImagePath("/Images/Features/SupplierInvoice.png"),
//         },
//         {
//           sTitle: "Observe Items with Insufficient Stock",
//           sPic: getImagePath("/Images/Features/InventoryInsufficient.png"),
//         },
//       ],
//       faqs: [
//         { q: "Can I record materials received from suppliers?", a: "Yes. You can create <b>Purchase Inward (GRN)</b> entries to record materials received into inventory." },
//         { q: "Can I create purchase orders before buying from suppliers?", a: "Yes. You can create and manage <b>Purchase Orders (PO)</b> to place orders with suppliers." },
//         { q: "Can I edit purchase orders or supplier invoices later?", a: "Yes. You can edit and update purchase orders or supplier invoices whenever required." },
//         { q: "Can I add extra fields in purchase orders?", a: "Yes. You can add additional columns or fields in purchase orders according to your business needs." },
//         { q: "Can I send reminders to suppliers for purchase orders?", a: "Yes. You can send reminders to suppliers via <b>Email or WhatsApp</b> directly from the purchase order." },
//         { q: "Can I analyze purchase and trade profitability?", a: "Yes. QikERP provides reports to compare <b>purchases vs sales</b> and analyze profitability." },
//       ],
//     },
//     {
//       id: "inventory",
//       title: "Inventory",
//       img: "/Images/Icons/Inventory.png",
//       tagline: "Stock smartly!",
//       items: [
//         "Track Inventory Stock",
//         "Manage Stock at Multiple Stores",
//         "Observe Items with Insufficient Stock",
//         "Easy Item Entry",
//         "Log Batches & Expiry Dates",
//         "Manage BOM (Bill of Materials)",
//         "Track Inventory Transactions",
//         "Monitor through Reports"
//       ],
//       screens: [
//         {
//           sTitle: "Track Inventory Stock",
//           sPic: getImagePath("/Images/Features/InventoryStockList.png"),
//         },
//         {
//           sTitle: "Manage Stock at Multiple Stores",
//           sPic: getImagePath("/Images/Features/InventoryStores.png"),
//         },
//         {
//           sTitle: "Observe Items with Insufficient Stock",
//           sPic: getImagePath("/Images/Features/InventoryInsufficient.png"),
//         },
//         {
//           sTitle: "Easy Item Entry",
//           sPic: getImagePath("/Images/Features/InventoryItemEntry.png"),
//         },
//         {
//           sTitle: "Log Batches & Expiry Dates",
//           sPic: getImagePath("/Images/Features/InventoryItemBatches.png"),
//         },
//         {
//           sTitle: "Manage BOM (Bill of Materials)",
//           sPic: getImagePath("/Images/Features/InventoryBOM.png"),
//         },
//         {
//           sTitle: "Track Inventory Transactions",
//           sPic: getImagePath("/Images/Features/InventoryXnTypes.png"),
//         },
//         {
//           sTitle: "Monitor through Reports",
//           sPic: getImagePath("/Images/Features/InventoryReports.png"),
//         },
//       ],
//       faqs: [
//   { q: "Can I manage multiple stores or warehouses?", a: "Yes. QikERP allows you to manage multiple stores or warehouses within the system." },
//   { q: "Can I manage both raw materials and finished products?", a: "Yes. You can manage <b>raw materials, finished goods, spares, and assemblies in inventory.</b>" },
//   { q: "Can I increase stock when items are received?", a: "Yes. You can increase stock when items are received from purchases or production." },
//   { q: "Can I reduce stock when items are issued or dispatched?", a: "Yes. Stock automatically reduces when items are <b>dispatched or issued for production.</b>" },
//   { q: "Can I track all stock movements?", a: "Yes. You can track <b>stock inward, dispatch, issues, and all inventory transactions through inventory reports.</b>" },
//   { q: "Can I import inventory items using Excel?", a: "Yes. You can quickly import inventory items using an <b>Excel template instead of adding them manually.</b>" }
// ]
//     },
//     {
//       id: "manufacturing",
//       title: "Production",
//       img: "/Images/Icons/Manufacturing.png",
//       tagline: "Make (smartly) in India!",
//       items: [
//         "Launch Production Jobs",
//         "Track WIP at Process Stages",
//         "Monitor Material Consumption vs BOM",
//         "Analyze Rejection Reasons",
//         "Track Job Status against Plan",
//         "Print Manufacturing Job Card"
//       ],
//       screens: [
//         {
//           sTitle: "Easy Production Job Entry",
//           sPic: getImagePath("/Images/Features/ProductionJobEntry.png"),
//         },
//         {
//           sTitle: "Monitor Manufacturing (WIP) Jobs",
//           sPic: getImagePath("/Images/Features/ProductionList.png"),
//         },
//         {
//           sTitle: "Track Job Status, Monitor Issued Materials",
//           sPic: getImagePath("/Images/Features/ProductionJobDetails.png"),
//         },
//         {
//           sTitle: "Monitor through Reports",
//           sPic: getImagePath("/Images/Features/ProductionReports.png"),
//         },
//         {
//           sTitle: "Track Job Status against Plan",
//           sPic: getImagePath("/Images/Features/ProductionJobTracking.png"),
//         },
//         {
//           sTitle: "Manufacturing Job Card Print Sample",
//           sPic: getImagePath("/Images/Features/ProductionJobCard.png"),
//         }
//       ],
//       faqs: [
//         { q: "Can I define my own production stages and process flow?", a: "Yes. You can create and manage your own production stages and workflows according to your manufacturing process." },
//         { q: "Can different products have different production stages?", a: "Yes. You can set different production stages and process flows for different products." },
//         { q: "Can I add or reject items during production?", a: "Yes. You can add more items or reject items even after the production job has been created." },
//         { q: "Can I analyze my production with reports?", a: "Yes. QikERP provides multiple production reports such as <b>Consumption Analysis, Rejection Cause Analysis, Production History, Product-wise Manufacturing Analysis, Production Job Analysis, Completion Punctuality, and Production Output</b>." },
//       ],
//     },
//     {
//       id: "support",
//       title: "Support",
//       img: "/Images/Icons/Support Ticketing.png",
//       tagline: "Quicken Customer Care!",
//       items: [
//         "Enter & Acknowledge Support Tickets",
//         "Track for Timely Completion",
//         "Request Feedback on Satisfaction"
//       ],
//       screens: [
//         {
//           sTitle: "Support Tickets Management",
//           sPic: getImagePath("/Images/Features/Support.png"),
//         },
//         {
//           sTitle: "Track Status",
//           sPic: getImagePath("/Images/Features/SupportDue.png"),
//         },
//         {
//           sTitle: "Support Feedback",
//           sPic: getImagePath("/Images/Features/SupportFeedback.png"),
//         },
//       ],
//       faqs: [
//         { q: "Can I create support tickets for customer issues?", a: "Yes. You can create support tickets and track them with a due date." },
//         { q: "Can I track the status of support tickets?", a: "Yes. You can track ticket status such as <b>Work in Progress (WIP) or Done</b>." },
//         { q: "Can I assign tickets to team members?", a: "Yes. You can assign support tickets to different team members." },
//         { q: "Can I add comments or updates on a ticket?", a: "Yes. You can add notes inside the support ticket." },
//         { q: "Can I notify customers about ticket status updates?", a: "Yes. You can send ticket status updates and request feedback from customers via <b>Email or WhatsApp</b>." },
//       ],
//     },
//     {
//       id: "contracts",
//       title: "Contracts",
//       img: "/Images/Icons/Contracts.png",
//       tagline: "Renew in time!",
//       items: [
//         "Enter Contracts Easily",
//         "Track Contracts & Subscriptions",
//         "Attach Contract File"
//       ],
//       screens: [
//         {
//           sTitle: "Enter Contracts Easily",
//           sPic: getImagePath("/Images/Features/ContractEntry.png"),
//         },
//         {
//           sTitle: "Track Contracts & Subscriptions",
//           sPic: getImagePath("/Images/Features/ContractManage.png"),
//         },
//         {
//           sTitle: "Attach Contract File",
//           sPic: getImagePath("/Images/Features/ContractEntry.png"),
//         },
//       ],
//       faqs: [
//         { q: "Can I set contract start and end dates?", a: "Yes. You can define start and end dates for contracts and track them accordingly." },
//         { q: "Can I track active and expired contracts?", a: "Yes. You can view active and inactive contracts and also filter contracts due for renewal <b>this month, next month, or within the next 12 months</b>." },
//         { q: "Can I attach documents or agreement files to contracts?", a: "Yes. You can attach agreement documents directly to the contract for easy reference." },
//         { q: "Can I manage AMC (Annual Maintenance Contracts)?", a: "Yes. You can manage <b>AMC contracts</b>, track their duration, and monitor renewals." },
//         { q: "Can I set different renewal rates from the contract charges?", a: "Yes. You can define renewal charges separately from the original contract charges." },
//       ],
//     },
//     {
//       id: "tasks",
//       title: "Tasks",
//       img: "/Images/Icons/Tasks.png",
//       tagline: "Stay Organized!",
//       items: [
//         "Finish own tasks (Inbox)",
//         "Monitor delegated tasks (Outbox)",
//         "Log completed/paused tasks"
//       ],
//       screens: [
//         {
//           sTitle: "Manage Own Tasks in Inbox",
//           sPic: getImagePath("/Images/Features/TasksDesktop.png"),
//         },
//         {
//           sTitle: "Track Delegated Tasks in Outbox",
//           sPic: getImagePath("/Images/Features/TaskOutbox.png"),
//         },
//         {
//           sTitle: "Log Tasks",
//           sPic: getImagePath("/Images/Features/TaskPause.png"),
//         },
//       ],
//       faqs: [
//         { q: "Can I assign tasks to team members?", a: "Yes. You can assign tasks to specific team members and track their progress." },
//         { q: "Can I set deadlines for tasks?", a: "Yes. You can define due dates for tasks to ensure work is completed on time." },
//         { q: "Can I track the status of tasks?", a: "Yes. You can update and track task status such as <b>Pending, Work in Progress, or Completed</b>." },
//         { q: "Can I add notes or updates to a task?", a: "Yes. You can add <b>details and updates</b> within the task to keep everyone informed." },
//         { q: "Can I set priority for tasks?", a: "Yes. You can set task priorities such as <b>High, Medium, or Normal</b> to manage work more effectively." },
//         { q: "Can I send reminders to team members for their tasks?", a: "Yes. You can easily send task reminders to your team members to ensure work is completed on time." },     
//       ],
//     },
//   ];

  const features = productFeatures

  const summaryData = [
    {
      title: "Growth Tools",
      color: "#E88421",
      items: [
        "Lead Import",
        "Funnel",
        "Assignment",
        "Interactions",
        "Follow-ups",
        "Visit Geo-Tag",
        "Quotations",
        "Proforma Invoices",
        "Sales Orders",
        "Billing",
        "POS Print",
        "Contracts",
        "AMCs",
        "Support Ticketing",
        "Status Updates",
        "Customer Login",
      ],
    },
    {
      title: "Smart Operations",
      color: "#DBA71A",
      items: [
        "Inventory",
        "Multiple Stores",
        "Batches",
        "Expiry",
        "Min levels",
        "BOM",
        "Purchase Planning",
        "Purchase Orders",
        "GRN",
        "Material Issue",
        "Stock Reconciliation",
        "Production Jobs",
        "MRP",
        "WIP Stage Movement",
        "Consumption",
        "Stock Availability",
        "Rejection Analysis",
        "Backflush",
        "Projects",
        "Tasks",
      ],
    },
    {
      title: "Easy Accounting",
      color: "#0B5D1F",
      items: [
        "Balance Sheet",
        "P&L",
        "Trial Balance",
        "Vouchers",
        "Ledger Record",
        "Ledger Import",
        "Sales Billing",
        "GSTR-1",
        "GSTR-3B",
        "E-Way Bill",
        "E-Invoice",
        "Purchases",
        "Mobile Access & Entry",
      ],
    },
    {
      title: "Integrations",
      color: "#15304A",
      items: [
        "IndiaMART",
        "TradeIndia",
        "JustDial",
        "Meta forms",
        "99Acres",
        "MagicBricks",
        "Website API",
        "Tally (invoices)",
        "Voucher import",
        "Excel export",
        "Gmail (outbound)",
        "E-Way Bill",
        "E-Invoice",
      ],
    },
  ];

  const subFeatureImageMap = {
    // --- Growth Tools ---
    "Lead Import": "/Images/Features/LeadIntegrations.png",
    Funnel: "/Images/Features/LeadProspFunnel.png",
    Assignment: "/Images/Features/LeadMgmtAssign.png",
    Interactions: "/Images/Features/LeadProspInxnsNew.png",
    "Follow-ups": "/Images/Features/LeadProspInxnsNew.png",
    "Visit Geo-Tag": "/Images/Features/LeadProspTravelHistory.png",
    Quotations: "/Images/Features/QuoteList.png",
    "Proforma Invoices": "/Images/Features/InvoiceProforma.png",
    "Sales Orders": "/Images/Features/InvoiceList.png",
    Billing: "/Images/Features/InvoiceEntryB2B.png",
    "POS Print": "/Images/Features/InvoicePrintCashMemo.png",
    Contracts: "/Images/Features/Contracts.png",
    AMCs: "",
    "Support Ticketing": "/Images/Features/Support.png",
    "Status Updates": "/Images/Features/StatusUpdate.png",
    "Customer Login": "",

    // --- Smart Operations ---
    Inventory: "/Images/Features/InventoryStockList.png",
    "Multiple Stores": "/Images/Features/InventoryStores.png",
    Batches: "/Images/Features/InventoryItemBatches.png",
    Expiry: "/Images/Features/InventoryItemBatches.png",
    "Min levels": "/Images/Features/InventoryInsufficient.png",
    BOM: "/Images/Features/InventoryBOM.png",
    "Purchase Planning": "/Images/Features/InventoryInsufficient.png",
    "Purchase Orders": "/Images/Features/PurchaseOrders.png",
    GRN: "/Images/Features/InventoryXnTypes.png",
    "Material Issue": "/Images/Features/InventoryXnTypes.png",
    "Stock Reconciliation": "/Images/Features/InventoryStores.png",
    "Production Jobs": "/Images/Features/ProductionList.png",
    MRP: "",
    "WIP Stage Movement": "/Images/Features/ProductionJobMovement.png",
    Consumption: "/Images/Features/ProductionJobDetails.png",
    "Stock Availability": "/Images/Features/InventoryStockList.png",
    "Rejection Analysis": "/Images/Features/ProductionReports.png",
    Backflush: "",
    Projects: "/Images/Features/Projects.png",
    Tasks: "/Images/Features/TasksDesktop.png",

    // --- Easy Accounting ---
    "Balance Sheet": "/Images/Features/AccountsStatements.png",
    "P&L": "/Images/Features/AccountsP&LMob.png",
    "Trial Balance": "/Images/Features/AccountsStatements.png",
    Vouchers: "/Images/Features/AccountsVoucherEntry.png",
    "Ledger Record": "/Images/Features/Ledger.png",
    "Ledger Import": "",
    "Sales Billing": "/Images/Features/InvoiceList.png",
    "GSTR-1": "",
    "GSTR-3B": "/Images/Features/InvoiceGSTR3B.png",
    "E-Way Bill": "/Images/Features/InvoiceEway.png",
    "E-Invoice": "/Images/Features/InvoicePrintEInvoice.png",
    Purchases: "/Images/Features/Purchases.png",
    "Mobile Access & Entry": "/Images/Features/AccountsDsbdMob.png",

    // --- Integrations ---
    IndiaMART: "/Images/Features/LeadIntegrations.png",
    TradeIndia: "/Images/Features/LeadIntegrations.png",
    JustDial: "/Images/Features/LeadIntegrations.png",
    "Meta forms": "/Images/Features/LeadIntegrations.png",
    "99Acres": "/Images/Features/LeadIntegrations.png",
    MagicBricks: "/Images/Features/LeadIntegrations.png",
    "Website API": "/Images/Features/LeadIntegrations.png",
    "Tally (invoices)": "",
    "Voucher import": "",
    "Excel export": "",
    "Gmail (outbound)": "",
    "E-Way Bill (Integration)": "/Images/Features/InvoiceEway.png",
    "E-Invoice (Integration)": "/Images/Features/InvoicePrintEInvoice.png",
  };

  const handleTickClick = (item, sectionColor) => {
    // Find the mapped image or use the default
    const imagePath = subFeatureImageMap[item];

    // Prevent action if image path is empty
    if (!imagePath || imagePath === "") return;

    setSelectedSubFeature({
      title: item,
      color: sectionColor,
      img: getImagePath(imagePath),
    });
  };

  const [highlightedIndex, setHighlightedIndex] = useState(null);

  const highlightDone = useRef(false);
  const highlightIndex = useRef(0);

  useEffect(() => {
    if (selectedFeature || selectedSubFeature) return;
    // if (highlightDone.current) return;

    const total = features.length;

    // 1 To show the effect only once

    // const interval = setInterval(() => {
    //   setHighlightedIndex(highlightIndex.current);
    //   highlightIndex.current++;
    //   if (highlightIndex.current >= total) {
    //     clearInterval(interval);
    //     setTimeout(() => {
    //       setHighlightedIndex(null);
    //       highlightDone.current = true;
    //     }, 600);
    //   }
    // }, 2000);

    // 2 To show the effect in Loop

    const interval = setInterval(() => {
      setHighlightedIndex(highlightIndex.current);
      highlightIndex.current++;
      if (highlightIndex.current >= total + 1) {
        highlightIndex.current = 0;
        setHighlightedIndex(null);
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [selectedFeature, selectedSubFeature]);

  return (
    <section
      id="ProductFeatures"
      className={`${!isMobile ? "bg-white" : "bg-background-light"} border-top py-12 md:py-20`}
    >
      <Container>
        {/* Header */}
        <div className="text-center mb-4 md:mb-12">
          <h3 className="text-[30px] md:text-[40px] font-bold secttl mb-3 px-6 md:px-10">
            ERP Modules
          </h3>
          <div className="text-[14px] md:text-lg text-[#808080] px-2">
            {isMobile ? (
              // <img
              //   src={getImagePath("/Images/Icons/HeroIcon.png")}
              //   className="mx-auto"
              //   alt="Features"
              // />
              <>
                <span className="text-[20px] mt-10 text-text-primary font-bold">Click any module to explore details or browse the total package below.</span>
                {/* <h1 className="text-[20px] mt-10 text-text-primary font-bold">ERP Modules</h1> */}
              </>
            ) : (
              <span>
                Click any ERP module below to explore details of its{" "}
                <b>Features</b> and preview its <b>Sample Screenshots</b>.
              </span>
            )}
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-16 md:gap-18 items-stretch">
          {/* Left Side: Icon Grid (4R 3C format for Desktop) */}
          <div className="w-full lg:w-[30%] flex flex-col justify-center items-center">
            <h3 className="text-md w-auto hidden md:flex md:text-lg font-bold text-gray-800 mb-4 text-center">
              ERP Modules
            </h3>

            <div className="grid grid-cols-3 gap-3 md:gap-4 md:w-auto w-full">
              {features.map((item) => (
                <div
                    key={item.id}
                   className={`w-full ${isMobile ? "bg-white" : "bg-background-light"} rounded-[7px] border-2 flex flex-col items-center justify-center p-[16px] px-[10px] md:px-8 cursor-pointer shadow-lg hover:shadow-xl transition-all duration-300 group
                      ${highlightedIndex === features.indexOf(item)
                        ? `${activeBrand === 'bz' ? 'ring-1 ring-[#e88421] border-[#e88421]' : 'ring-1 ring-[#0b5d1e] border-[#0b5d1e]'} shadow-md`
                        : 'border-border'
                      }
                      ${activeBrand === 'bz' ? 'hover:border-[#e88421]' : 'hover:border-[#0b5d1e]'}
                    `}
                    onClick={() => {
                      setSelectedFeature(item);
                      onFeatureClick?.(item.title);
                    }}
                  >
                  <img
                    src={getImagePath(item.img)}
                    alt={item.title}
                    className={`w-[40px] md:w-[60px] h-[60px] md:h-[60px] object-contain mb-2 pt-2 transition-transform ${
                      item.id === "crm" ? "pt-4" : ""
                    }`}
                  />

                  <span className="text-[13px] md:text-[13px] font-semibold text-text-primary text-center leading-tight">
                    {item.title}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Side: Total Package Summary */}
      <div className="w-full lg:w-[70%] justify-center flex flex-col">
        <h3 className="text-[30px] secttl md:text-xl font-bold text-gray-800 mb-6 md:mb-4 text-center">
          {/* Total Package for <br className="md:hidden flex "></br> Smart
          Business */}
          Feature List
        </h3>

        <div className="flex-1 flex flex-col">
          {/* 2x2 Grid for Desktop, Single Column for Mobile */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4 md:gap-y-4 h-full">
            {summaryData.map((section) => (
              <div
                key={section.title}
                className={`flex ${isMobile ? "bg-white" : "bg-background-light"} rounded-[7px] border border-border flex-col p-4`}
              >

                    <h4
                      className="text-[15px] md:text-[17px] font-bold mb-3"
                      style={{ color: section.color }}
                    >
                      {section.title}
                    </h4>
                    <div className="flex flex-wrap md:gap-x-2.5 gap-x-2  md:gap-y-2.5 gap-y-2">
{section.items.map((item, i) => {
  const hasImage =
    subFeatureImageMap[item] && subFeatureImageMap[item] !== "";

  const style = {
    backgroundColor: `${section.color}0D`,
    borderColor: hasImage ? `${section.color}40` : `${section.color}55`,
  };

  return (
    <div
      key={i}
      onClick={() => hasImage && handleTickClick(item, section.color)}
      style={style}
      className={`
        inline-flex items-center gap-1.5 text-[12px] group font-medium rounded-md px-2.5 py-1 border
        transition-all duration-100 select-none shadow-sm shadow-black/20
        ${hasImage ? "cursor-pointer hover:brightness-90 active:scale-95" : "cursor-default"}
      `}
    >
      {/* Tick always section color */}
      <span
        className="font-bold text-[13px] leading-none"
        style={{ color: section.color }}
      >
        ✓
      </span>

      {/* Text behavior */}
      <span
        className="leading-snug"
        style={{ color: "#333" }}
        onMouseEnter={(e) => {
          if (hasImage) e.currentTarget.style.color = section.color;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = "#333";
        }}
      >
        {item}
      </span>
    </div>
  );
})}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* Main Modal: Screenshots & Detailed Items (for Icons) */}
      <FeatureDetails
        isOpen={!!selectedFeature}
        onClose={() => setSelectedFeature(null)}
        feature={selectedFeature}
        onBuyNow={handleModalBuyNow}
      />

      {/* Quick Modal: For individual tick-mark clicks */}
      <ProductFeatureDetails
        isOpen={!!selectedSubFeature}
        onClose={() => setSelectedSubFeature(null)}
        feature={selectedSubFeature}
        onBuyNow={handleModalBuyNow}
      />
    </section>
  );
};

export default ProductFeatures;
